export const grid_accessibility_options = {
  ensureDomOrder: true,
  suppressColumnVirtualisation: true,
};
